export const Footer = () => {
  return (
    <footer className="py-8 bg-gray-100">
      <div className="container">
        <p className="text-center">© 2024 zooon</p>
      </div>
    </footer>
  );
};
